import React, { useEffect, useRef, useState } from "react";
import "./TextBox.scss";
import { SLableIcon } from "../../Typography";
import { Info, Verified } from "../../icons";

const OTPinput = ({
  length = 4, // number of otp count
  value = "", // mandatory attribute
  onChange, // mandatory attribute
  size = "md", // input size
  status = "", // "", "error", "verified"
  statusMessage = "", // custom status message
  disabled = false, // input disabled or not
  autoFocus = false, // pre focus input or not
}) => {
  /* useStates */

  const [isAnyFocused, setIsAnyFocused] = useState(false); // changed to + from single index

  /* end useStates */

  /* useRef */
  const inputsRef = useRef([]); // otp boxes selector
  /* end useRef */

  /* otp logic */

  useEffect(() => {
    if (autoFocus && inputsRef.current[0]) {
      inputsRef.current[0].focus();
    }
  }, [autoFocus]); // initialize if parameter "autoFocus" is true to focus first input

  const handleChange = (e, idx) => {
    const input = e.target.value.replace(/[^0-9]/g, "").slice(-1); // only numbers
    const newValue = value.split("");
    newValue[idx] = input;
    onChange(newValue.join(""));
    if (input && idx < length - 1) {
      inputsRef.current[idx + 1].focus();
    }
  }; // just allow numbers and after typed one number it go to nest input

  const handleKeyDown = (e, idx) => {
    if (e.key === "Backspace" && !value[idx] && idx > 0) {
      const newValue = value.split("");
      newValue[idx - 1] = "";
      onChange(newValue.join(""));
      inputsRef.current[idx - 1].focus();
    }
  }; // on back space go to previous input

  const handlePaste = (e) => {
    e.preventDefault();
    const pasted = e.clipboardData.getData("Text").slice(0, length);
    const clean = pasted.replace(/[^0-9]/g, "");
    const split = clean.split("");
    const padded = Array(length)
      .fill("")
      .map((_, i) => split[i] || "");
    onChange(padded.join(""));
    const nextIndex = Math.min(
      padded.findIndex((c) => c === "") || length - 1,
      length - 1
    );
    /* inputsRef.current[nextIndex].focus(); */
  }; // pest the copied otp

  const handleFocus = () => setIsAnyFocused(true); // if the any input is in focus then it show the entered otp

  const handleBlur = () => {
    setTimeout(() => {
      const isStillFocused = inputsRef.current.some(
        (input) => input && input === document.activeElement
      );
      setIsAnyFocused(isStillFocused);
    }, 0); // Delay check to allow focus switching between boxes
  }; // after blur the input it change back to encoded otp

  const icon = status === "verified" ? Verified : Info; // otp true or false change icon logic

  /* end otp logic */

  const prenetWrapper = `otp-container ${status} ${size} ${
    disabled ? "disabled" : ""
  }`; // input parent wrapper
  const inputPrenetClasses = `borderWrapper OtpInputs`; // input parent class
  const inputClasses = `otp-box borderInner ${status}`; // input classes

  return (
    <div className="otp-wrapper">
      <div className={prenetWrapper}>
        {Array.from({ length }).map((_, i) => (
          <div key={i} className={inputPrenetClasses}>
            <input
              type="text"
              inputMode="numeric"
              maxLength={1}
              value={value[i] ? (isAnyFocused ? value[i] : "+") : ""}
              disabled={disabled}
              onChange={(e) => handleChange(e, i)}
              onFocus={handleFocus}
              onBlur={handleBlur}
              onKeyDown={(e) => handleKeyDown(e, i)}
              onPaste={handlePaste}
              ref={(el) => (inputsRef.current[i] = el)}
              className={inputClasses}
              placeholder="-"
            />
          </div>
        ))}
      </div>

      {statusMessage && (
        <SLableIcon
          size={size}
          icon={icon}
          className={`otp-status-message ${status}`}
        >
          {statusMessage}
        </SLableIcon>
      )}
    </div>
  );
};

export default OTPinput;
